export default {"src":"https://js-static.hirist.tech/production/21.0.1/_next/static/media/eye.ef575733.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};